import { c as compute_rest_props, b as compute_slots, s as subscribe, f as set_store_value } from "./utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, v as validate_component, i as each, k as add_classes } from "./ssr.js";
import "./client.js";
import { C as CardLayout } from "./CardLayout.js";
import { I as InfoBox } from "./InfoBox.js";
import { B as Button } from "./Button.js";
import { T as Textarea } from "./Textarea.js";
import { T as Toggle } from "./Toggle.js";
import { H as Hr } from "./Hr.js";
import { P as PenOutline } from "./PenOutline.js";
import { C as CardLayoutSubmitButton } from "./CardLayoutSubmitButton.js";
import { I as Input } from "./Input.js";
import dayjs from "dayjs";
import { a as asSelectItems, m as maritalStatus, g as genderOptions } from "./options.js";
import { p as post } from "./api.js";
import { T as Typeahead } from "./Typeahead.js";
import { twMerge } from "tailwind-merge";
import { w as writable } from "./index2.js";
import { a as allUnits } from "./unit.js";
import { E as ExclamationCircleOutline } from "./ExclamationCircleOutline.js";
import { T as Tooltip } from "./Tooltip.js";
const MinusOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "minus outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M5 12h14"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M5 12h14"></path></svg>`} `;
});
const VerticalGrid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$slots = compute_slots(slots);
  return `<div class="grid lg:grid-cols-2 gap-5 px-2"><div class="block flex-1 space-y-4 ">${slots.default ? slots.default({}) : ``}</div> ${$$slots["right"] ? `<div class="flex-1 block lg:border-l border-neutral-100 space-y-4 lg:pl-6">${slots.right ? slots.right({}) : ``}</div>` : ``}</div>`;
});
const ApplyTrigger = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_trigger_submits;
  let { loading = false } = $$props;
  let button_to_submit;
  let trigger_submits = getContext("trigger_submits");
  $$unsubscribe_trigger_submits = subscribe(trigger_submits, (value) => value);
  if ($$props.loading === void 0 && $$bindings.loading && loading !== void 0) $$bindings.loading(loading);
  $$unsubscribe_trigger_submits();
  return `<button hidden ${loading ? "disabled" : ""}${add_attribute("this", button_to_submit, 0)}></button>`;
});
const IncompleteDataWarning = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { complete } = $$props;
  if ($$props.complete === void 0 && $$bindings.complete && complete !== void 0) $$bindings.complete(complete);
  return `${!complete ? `${validate_component(ExclamationCircleOutline, "ExclamationCircleOutline").$$render($$result, { class: "w-8 h-8 text-red-500" }, {}, {})} ${validate_component(Tooltip, "Tooltip").$$render($$result, {}, {}, {
    default: () => {
      return `Unvollständige Daten`;
    }
  })}` : ``}`;
});
const Qualifications = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let complete;
  let $employee, $$unsubscribe_employee;
  let $$unsubscribe_super_edit;
  let $employee_extra, $$unsubscribe_employee_extra;
  let { readOnly = false } = $$props;
  let loading = false;
  let display = false;
  const employee_extra = getContext("employee_extra");
  $$unsubscribe_employee_extra = subscribe(employee_extra, (value) => $employee_extra = value);
  let employee = getContext("employee");
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  let super_edit = getContext("super_edit");
  $$unsubscribe_super_edit = subscribe(super_edit, (value) => value);
  if ($$props.readOnly === void 0 && $$bindings.readOnly && readOnly !== void 0) $$bindings.readOnly(readOnly);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    complete = $employee.cv.degree && $employee.cv.graduation && $employee.cv.shirtSize && $employee.cv.pantsSize && $employee.cv.shoeSize && $employee.cv.height && $employee.cv.hairColor;
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "Qualifikationen",
        accordion: true,
        display
      },
      {
        display: ($$value) => {
          display = $$value;
          $$settled = false;
        }
      },
      {
        "card-header": () => {
          return `${validate_component(IncompleteDataWarning, "IncompleteDataWarning").$$render($$result, { complete }, {}, {})} ${!readOnly ? `${validate_component(Button, "Button").$$render(
            $$result,
            {
              color: "yellow",
              class: "!p-2",
              pill: true,
              outline: true
            },
            {},
            {
              default: () => {
                return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 h-4" }, {}, {})}`;
              }
            }
          )}` : ``} `;
        },
        default: () => {
          return `<form class="${["px-2 py-3", ""].join(" ").trim()}" method="post" action="?/update_employee_qualifications">${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
            right: () => {
              return ` ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Ausbildung",
                  value: $employee.cv.degree,
                  name: "degree"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Hosengröße",
                  value: $employee.cv.pantsSize,
                  name: "pantsSize"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Führerschein",
                  value: $employee.cv?.motorVehicleLicense !== "0" ? "Ja" : "Kein Führerschein"
                },
                {},
                {
                  default: ({ value, x_name }) => {
                    return `${validate_component(Toggle, "Toggle").$$render(
                      $$result,
                      {
                        name: "motorVehicleLicense",
                        id: x_name,
                        value: $employee.cv.motorVehicleLicense,
                        checked: $employee.cv.motorVehicleLicense !== "0"
                      },
                      {},
                      {}
                    )}`;
                  }
                }
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Haarfarbe",
                  value: $employee.cv.hairColor,
                  name: "hairColor"
                },
                {},
                {}
              )} `;
            },
            default: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Schulabschluss",
                  value: $employee.cv.graduation,
                  name: "graduation",
                  type: "select",
                  items: $employee_extra.graduations?.map((n) => ({ ...n, name: n.value }))
                },
                {},
                {}
              )}  ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Hemdgröße",
                  value: $employee.cv.shirtSize,
                  name: "shirtSize"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Schuhgröße (EU)",
                  type: "number",
                  step: "0.5",
                  value: $employee.cv.shoeSize,
                  name: "shoeSize"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Körpergröße (cm)",
                  value: $employee.cv.height,
                  name: "height"
                },
                {},
                {}
              )}`;
            }
          })} ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <div class="px-2 ">${validate_component(InfoBox, "InfoBox").$$render(
            $$result,
            {
              title: "Erfahrung",
              value: $employee.cv.workExperiences,
              name: "workExperiences"
            },
            {},
            {
              default: () => {
                return `${validate_component(Textarea, "Textarea").$$render(
                  $$result,
                  {
                    name: "workExperiences",
                    value: $employee.cv.workExperiences
                  },
                  {
                    value: ($$value) => {
                      $employee.cv.workExperiences = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )}`;
              }
            }
          )}</div> ${validate_component(CardLayoutSubmitButton, "CardLayoutSubmitButton").$$render($$result, {}, {}, {})} ${validate_component(ApplyTrigger, "ApplyTrigger").$$render($$result, { loading }, {}, {})}</form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_employee();
  $$unsubscribe_super_edit();
  $$unsubscribe_employee_extra();
  return $$rendered;
});
const BankAccount = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $employee, $$unsubscribe_employee;
  let $super_edit, $$unsubscribe_super_edit;
  let { readOnly = false } = $$props;
  const employee = getContext("employee");
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  const super_edit = getContext("super_edit");
  $$unsubscribe_super_edit = subscribe(super_edit, (value) => $super_edit = value);
  let loading = false;
  let display = false;
  let complete = false;
  getContext("employee_extra");
  if ($$props.readOnly === void 0 && $$bindings.readOnly && readOnly !== void 0) $$bindings.readOnly(readOnly);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    complete = !!($employee.bankAccount && $employee.bankAccount.accountName && $employee.bankAccount.iban && $employee.bankAccount.bicSwift);
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "Zahlungsart",
        accordion: true,
        display
      },
      {
        display: ($$value) => {
          display = $$value;
          $$settled = false;
        }
      },
      {
        "card-header": () => {
          return `${validate_component(IncompleteDataWarning, "IncompleteDataWarning").$$render($$result, { complete }, {}, {})} ${!readOnly ? `${validate_component(Button, "Button").$$render(
            $$result,
            {
              color: "yellow",
              class: "!p-2",
              pill: true,
              outline: true
            },
            {},
            {
              default: () => {
                return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 h-4" }, {}, {})}`;
              }
            }
          )}` : ``} `;
        },
        default: () => {
          return `<form class="${["px-2 py-3", ""].join(" ").trim()}" method="post" action="?/update_bank_info">${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
            right: () => {
              return `${$employee.bankAccount ? `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "IBAN",
                  name: "iban",
                  value: $employee?.bankAccount?.iban
                },
                {},
                {
                  default: () => {
                    return `${validate_component(Input, "Input").$$render(
                      $$result,
                      {
                        type: "text",
                        name: "iban",
                        class: "w-full py-1 pl-1",
                        value: $employee.bankAccount.iban
                      },
                      {
                        value: ($$value) => {
                          $employee.bankAccount.iban = $$value;
                          $$settled = false;
                        }
                      },
                      {}
                    )}`;
                  }
                }
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  readonly: true,
                  title: "PLZ",
                  value: $employee?.bankAccount?.zip
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  readonly: true,
                  title: "Ort",
                  value: $employee?.bankAccount?.city
                },
                {},
                {}
              )}` : ``} ${$super_edit ? `${validate_component(CardLayoutSubmitButton, "CardLayoutSubmitButton").$$render($$result, {}, {}, {})} ${validate_component(ApplyTrigger, "ApplyTrigger").$$render($$result, { loading }, {}, {})}` : ``} `;
            },
            default: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Kontoinhaber",
                  name: "accountName",
                  value: $employee?.bankAccount?.accountName
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "BIC/SWIFT",
                  name: "bicSwift",
                  value: $employee?.bankAccount?.bicSwift
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Bank",
                  name: "bankName",
                  value: $employee?.bankAccount?.bankName
                },
                {},
                {}
              )}`;
            }
          })} ${``}</form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_employee();
  $$unsubscribe_super_edit();
  return $$rendered;
});
const referenceLanguages = writable([]);
const referenceCountries = writable([]);
const referenceEducation = writable([]);
const EmployeeLanguages = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_referenceLanguages;
  let $super_edit, $$unsubscribe_super_edit;
  $$unsubscribe_referenceLanguages = subscribe(referenceLanguages, (value) => value);
  let { employee } = $$props;
  let super_edit = getContext("super_edit");
  $$unsubscribe_super_edit = subscribe(super_edit, (value) => $super_edit = value);
  let newLanguage = "";
  let languages = [];
  let addLanguage = async (lang) => {
    if (!newLanguage) return;
    if (typeof employee.languages === "undefined") employee.languages = [];
    const languageObject = {
      employeeId: employee.id,
      languageIsoCode: lang.value
    };
    newLanguage = "";
    employee.languages = [
      ...(await post("/employee/" + employee.uuid + "/language", languageObject)).languages
    ];
  };
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
      right: () => {
        return `${$super_edit ? `${validate_component(Typeahead, "Typeahead").$$render(
          $$result,
          {
            placeholder: "Neue Sprache",
            extract: addLanguage,
            data: languages,
            value: newLanguage
          },
          {
            value: ($$value) => {
              newLanguage = $$value;
              $$settled = false;
            }
          },
          {}
        )}` : ``} `;
      },
      default: () => {
        return `<div class="font-medium block dark:text-gray-300 text-lg leading-6 text-gray-500" data-svelte-h="svelte-18bsmcf">Sprachen</div> ${languages.length > 0 ? `${each(employee.languages || [], (language) => {
          return `<div class="flex gap-1"><div class="flex-1">${validate_component(InfoBox, "InfoBox").$$render(
            $$result,
            {
              value: languages.find((x) => x.value === language.languageIsoCode)?.name,
              readonly: true
            },
            {},
            {}
          )}</div> ${$super_edit ? `${validate_component(Button, "Button").$$render($$result, { color: "red", pill: true, class: "!p-2" }, {}, {
            default: () => {
              return `${validate_component(MinusOutline, "MinusOutline").$$render($$result, { class: "w-4 h-4" }, {}, {})} `;
            }
          })}` : ``} </div>`;
        })}` : ``}`;
      }
    })}`;
  } while (!$$settled);
  $$unsubscribe_referenceLanguages();
  $$unsubscribe_super_edit();
  return $$rendered;
});
const EmployeeInfo = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let complete;
  let $referenceEducation, $$unsubscribe_referenceEducation;
  let $referenceCountries, $$unsubscribe_referenceCountries;
  let $$unsubscribe_allUnits;
  let $employee, $$unsubscribe_employee;
  let $$unsubscribe_super_edit;
  $$unsubscribe_referenceEducation = subscribe(referenceEducation, (value) => $referenceEducation = value);
  $$unsubscribe_referenceCountries = subscribe(referenceCountries, (value) => $referenceCountries = value);
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => value);
  let { display = true } = $$props;
  let { readOnly = false } = $$props;
  let loading = false;
  let employee = getContext("employee");
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  let super_edit = getContext("super_edit");
  $$unsubscribe_super_edit = subscribe(super_edit, (value) => value);
  let units = [];
  let affiliationEntered = $employee?.contracts.length > 0 ? $employee.contracts?.sort((a, b) => b.id - a.id)[0].history[0]?.startDate?.value : null;
  let stati = [];
  if ($$props.display === void 0 && $$bindings.display && display !== void 0) $$bindings.display(display);
  if ($$props.readOnly === void 0 && $$bindings.readOnly && readOnly !== void 0) $$bindings.readOnly(readOnly);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    complete = $employee.firstName && $employee.lastName && $employee.gender && $employee.cv.placeOfBirth && $employee.maidenName && $employee.dateOfBirth && $employee.cv.familyStatus && $employee.cv.degree && $employee.status && $employee.cv.countryOfBirth;
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "Stammdaten",
        accordion: true,
        display
      },
      {
        display: ($$value) => {
          display = $$value;
          $$settled = false;
        }
      },
      {
        "card-header": () => {
          return `${validate_component(IncompleteDataWarning, "IncompleteDataWarning").$$render($$result, { complete }, {}, {})} ${!readOnly ? `${validate_component(Button, "Button").$$render(
            $$result,
            {
              color: "yellow",
              class: "!p-2",
              pill: true,
              outline: true
            },
            {},
            {
              default: () => {
                return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 h-4" }, {}, {})}`;
              }
            }
          )}` : ``} `;
        },
        default: () => {
          return `<form method="post" action="?/update_base_data"${add_classes("".trim())}>${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
            right: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Nachname",
                  value: $employee.lastName,
                  name: "lastName"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Geburtsort",
                  name: "cv_placeOfBirth",
                  value: $employee.cv?.placeOfBirth
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Geburtsland",
                  items: $referenceCountries,
                  type: "select",
                  name: "cv_countryOfBirth",
                  value: $employee.cv?.countryOfBirth
                },
                {},
                {}
              )} <div class="flex gap-2"><div class="flex-1">${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Geburtsdatum",
                  name: "dateOfBirth",
                  type: "date",
                  value: $employee.dateOfBirth?.value ? dayjs($employee.dateOfBirth.value, "YYYY-MM-DD").format("YYYY-MM-DD") : ""
                },
                {},
                {}
              )}</div> <div class="pt-7">${escape(dayjs().diff(dayjs($employee.dateOfBirth?.value), "years", false))} Jahre</div></div> ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Ausbildung",
                  items: $referenceEducation,
                  type: "select",
                  value: $employee.cv?.degree,
                  name: "cv_degree"
                },
                {},
                {}
              )} ${$employee.status === "Hauptbeschäftigt" ? `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Beschäftigt bei",
                  value: $employee.cv.mainEmployer,
                  name: "cv_mainEmployer"
                },
                {},
                {}
              )}` : ``} `;
            },
            default: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Vorname",
                  value: $employee.firstName,
                  name: "firstName"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Geschlecht",
                  value: $employee.gender,
                  items: asSelectItems(genderOptions),
                  type: "select",
                  name: "gender"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Staatsangehörigkeit",
                  value: $employee.cv?.nationality,
                  name: "cv_nationality"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Geburtsnachname",
                  value: $employee.maidenName,
                  name: "maidenName"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Familienstand",
                  value: $employee.cv?.familyStatus || "-",
                  name: "cv_familyStatus",
                  items: Object.entries(maritalStatus).map(([key, value]) => ({ value: key, name: value })),
                  type: "select"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Aktueller Status",
                  value: $employee.status,
                  items: stati,
                  type: "select",
                  name: "status"
                },
                {},
                {}
              )}`;
            }
          })} ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} ${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
            right: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Firmeneintritt",
                  readonly: true,
                  value: affiliationEntered ? dayjs(affiliationEntered, "YYYY-MM-DD").format("DD.MM.YYYY") : ""
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Verifiziert am",
                  readonly: true,
                  value: dayjs.unix($employee.createdAt?.stamp).format("DD.MM.YYYY")
                },
                {},
                {}
              )} <div class="pt-2"></div> `;
            },
            default: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Quelle",
                  value: $employee.reference,
                  readonly: true
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  name: "unitId",
                  title: "Unit",
                  type: "select",
                  items: units,
                  value: $employee.unitId
                },
                {},
                {}
              )}`;
            }
          })} ${validate_component(CardLayoutSubmitButton, "CardLayoutSubmitButton").$$render($$result, {}, {}, {})} ${validate_component(ApplyTrigger, "ApplyTrigger").$$render($$result, { loading }, {}, {})}</form> <div class="pt-5">${validate_component(EmployeeLanguages, "EmployeeLanguages").$$render(
            $$result,
            { employee: $employee },
            {
              employee: ($$value) => {
                $employee = $$value;
                $$settled = false;
              }
            },
            {}
          )}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_referenceEducation();
  $$unsubscribe_referenceCountries();
  $$unsubscribe_allUnits();
  $$unsubscribe_employee();
  $$unsubscribe_super_edit();
  return $$rendered;
});
const TaxAndInsurance = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let complete;
  let $employee, $$unsubscribe_employee;
  let $super_edit, $$unsubscribe_super_edit;
  let $employee_extra, $$unsubscribe_employee_extra;
  let super_edit = getContext("super_edit");
  $$unsubscribe_super_edit = subscribe(super_edit, (value) => $super_edit = value);
  let { loading = false } = $$props;
  let { readOnly = false } = $$props;
  let employee = getContext("employee");
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  let display = false;
  const employee_extra = getContext("employee_extra");
  $$unsubscribe_employee_extra = subscribe(employee_extra, (value) => $employee_extra = value);
  if ($employee && !$employee?.healthInsurance) {
    set_store_value(employee, $employee.healthInsurance = {}, $employee);
  }
  if ($$props.loading === void 0 && $$bindings.loading && loading !== void 0) $$bindings.loading(loading);
  if ($$props.readOnly === void 0 && $$bindings.readOnly && readOnly !== void 0) $$bindings.readOnly(readOnly);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    complete = $employee.healthInsurance?.insuranceName && $employee.healthInsurance?.insuranceNumber && $employee?.cv?.taxationClass && $employee?.cv?.religiousAffiliation;
    $$rendered = `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: "Krankenversicherung (KV) / Lohnsteuer",
        accordion: true,
        display
      },
      {
        display: ($$value) => {
          display = $$value;
          $$settled = false;
        }
      },
      {
        "card-header": () => {
          return `${validate_component(IncompleteDataWarning, "IncompleteDataWarning").$$render($$result, { complete }, {}, {})} ${!readOnly ? `${validate_component(Button, "Button").$$render(
            $$result,
            {
              color: "yellow",
              class: "!p-2",
              pill: true,
              outline: true
            },
            {},
            {
              default: () => {
                return `${validate_component(PenOutline, "PenOutline").$$render($$result, { class: "w-4 h-4" }, {}, {})}`;
              }
            }
          )}` : ``} `;
        },
        default: () => {
          return `<form method="post" class="${["px-2 py-3", loading ? "opacity-20" : ""].join(" ").trim()}" action="?/health_insurance">${$employee.healthInsurance ? `${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
            right: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Name " + ($employee.healthInsurance.isPublic ? "gesetzliche" : "private") + " KV",
                  value: $employee.healthInsurance?.insuranceName || "",
                  name: "insuranceName",
                  items: $employee_extra.health_insurances?.map((n) => ({ ...n, name: n.value })).sort((a, b) => a.name.localeCompare(b.name)),
                  type: $employee.healthInsurance.isPublic ? "select" : "text"
                },
                {},
                {}
              )} ${!$employee.healthInsurance.isPublic ? `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Vorherige ges. Versicherung",
                  value: $employee.healthInsurance?.previouslyInsuredBy || "",
                  items: [
                    { name: "Keine", value: "" },
                    ...$employee_extra.health_insurances?.map((n) => ({ ...n, name: n.value })).sort((a, b) => a.name.localeCompare(b.name))
                  ],
                  type: "select",
                  name: "previouslyInsuredBy"
                },
                {},
                {}
              )}` : ``} `;
            },
            default: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Gesetzlich versichert",
                  value: $employee?.healthInsurance?.isPublic ? "Ja" : "Nein"
                },
                {},
                {
                  default: ({ value }) => {
                    return `${validate_component(Toggle, "Toggle").$$render(
                      $$result,
                      {
                        value: $employee.healthInsurance.isPublic,
                        disabled: !$super_edit,
                        name: "isPublic",
                        checked: $employee.healthInsurance.isPublic
                      },
                      {
                        checked: ($$value) => {
                          $employee.healthInsurance.isPublic = $$value;
                          $$settled = false;
                        }
                      },
                      {}
                    )}`;
                  }
                }
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Versicherungsnummer",
                  value: $employee.healthInsurance?.insuranceNumber || "",
                  name: "insuranceNumber"
                },
                {},
                {}
              )}`;
            }
          })}` : ``} ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} ${validate_component(VerticalGrid, "VerticalGrid").$$render($$result, {}, {}, {
            right: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Steuer ID",
                  value: $employee.taxId || "-",
                  name: "taxId"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Kinderfreibetrag",
                  name: "childAllowance",
                  type: "number",
                  step: "0.5",
                  value: $employee.cv.childAllowance || 0
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Familienstand",
                  value: $employee.cv?.familyStatus || "-",
                  name: "familyStatus",
                  items: Object.entries(maritalStatus).map(([key, value]) => ({ value: key, name: value })),
                  type: "select"
                },
                {},
                {}
              )} `;
            },
            default: () => {
              return `${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "SV-Nummer",
                  value: $employee.cv.socialSecurityNumber || "",
                  pattern: "[0-9]{8}[A-Z][0-9]{3}",
                  name: "socialSecurityNumber"
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Steuerklasse",
                  name: "taxationClass",
                  type: "number",
                  value: $employee.cv.taxationClass || ""
                },
                {},
                {}
              )} ${validate_component(InfoBox, "InfoBox").$$render(
                $$result,
                {
                  title: "Konfession",
                  value: $employee.cv.religiousAffiliation || "",
                  name: "religiousAffiliation",
                  items: $employee_extra.religious_denoms?.map((n) => ({ ...n, name: n.value })),
                  type: "select"
                },
                {},
                {}
              )}`;
            }
          })} ${validate_component(CardLayoutSubmitButton, "CardLayoutSubmitButton").$$render($$result, {}, {}, {})} ${validate_component(ApplyTrigger, "ApplyTrigger").$$render($$result, {}, {}, {})}</form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_employee();
  $$unsubscribe_super_edit();
  $$unsubscribe_employee_extra();
  return $$rendered;
});
export {
  ApplyTrigger as A,
  BankAccount as B,
  EmployeeInfo as E,
  IncompleteDataWarning as I,
  Qualifications as Q,
  TaxAndInsurance as T,
  VerticalGrid as V
};
//# sourceMappingURL=TaxAndInsurance.js.map
